module.exports = __webpack_public_path__ + "img/download-step2.39965191.png";